<template>
  <div class="h-100">
    <div class="content-page p-3 pb-5 h-100">
      <div class="row">
        <div
          class="col-12 text-right"
          v-if="hasRight(Settings.Permission.Change) && hasRight('AlwWrite')"
        >
          <button
            class="btn btn-info"
            @click="initAnnualLeavePlan"
            v-b-modal.modal-annualLeavePlan
          >
            {{ `${this.t.t(dictEnum.LBL_Add)} ` }}
          </button>
        </div>
      </div>
      <div class="row h-100">
        <div class="col-sm-12 h-100 pb-5">
          <div class="tab-content  bg-white h-100">
            <div class="tab-pane active table-responsive color-table">
              <table class="table table-bordered text-center">
                <thead
                  style="background: rgb(91, 165, 188);
    color: white !important;"
                >
                  <tr>
                    <th style="color: white !important;text-align:center">
                      {{ this.t.t(dictEnum.LBL_YearOfService) }}
                    </th>

                    <th
                      style="color: white !important;text-align:center"
                      v-for="(day, i) in annualLeavePlanDays"
                      :key="day.StaffGrade"
                    >
                      {{ day.StaffDesc }}
                    </th>
                    <th style="color: white !important;text-align:center">
                      {{ this.t.t(dictEnum.BTN_Update) }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(option, i) in tableData" :key="option.YOS">
                    <td>{{ option.YOS }}</td>

                    <td
                      v-for="grade in tableData[i].GradeEntitle"
                      :key="grade.StaffGrade"
                    >
                      {{ grade.DaysEntitle }}
                    </td>
                    <td>
                      <font-awesome-icon
                        icon="edit"
                        style="cursor:pointer"
                        v-if="hasRight(Settings.Permission.Change)"
                        v-b-modal.modal-annualLeavePlan
                        @click="editAnnualLeavePlan(option)"
                      />
                      <font-awesome-icon
                        icon="trash"
                        style="cursor:pointer"
                        v-if="hasRight(Settings.Permission.Change)"
                        @click="deleteAnnualLeavePlan(option)"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-annualLeavePlan"
      :title="mode === 'new' ? t.t(dictEnum.LBL_Add) : t.t(dictEnum.BTN_Update)"
      :ok-title="t.t(dictEnum.BTN_Submit)"
      :cancel-title="t.t(dictEnum.BTN_Cancel)"
      @ok="editOrAddAnnualLeavePlan"
    >
      <div class="p-3">
        <b-row class="my-1 no-gutters">
          <b-col cols="5">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{
                t.t(dictEnum.LBL_YearOfService)
              }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col cols="7">
            <b-form-group class="font-weight-normal">
              <b-form-input
                v-model="annualLeavePlan.YOS"
                :readonly="mode === 'new' ? false : true"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row
          class="row my-1 no-gutters"
          v-for="(staffGrade, i) in staffGradeList"
          :key="staffGrade.StaffGrade"
        >
          <b-col cols="5">
            <b-input-group-prepend is-text v-if="user.Lang == 'EN'">
              <span class="bg-white">{{ staffGrade.EDesc }}</span>
            </b-input-group-prepend>
            <b-input-group-prepend
              is-text
              v-if="user.Lang == 'TC' || user.Lang == 'SC'"
            >
              <span class="bg-white">{{ staffGrade.CDesc }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col cols="7">
            <b-form-group class="font-weight-normal">
              <b-form-input
                v-model="staffGradeALDays[staffGrade.StaffGrade]"
                maxlength="2"
                @keypress="inputDigitOnly"
              ></b-form-input>
              <!--onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"-->
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MenuRightSerivce from "@/service/MenuRightService";
import LeavePlanService from "@/service/LeavePlanService";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import { AnnualLeavePlan } from "@/model/AnnualLeavePlan";
import { AnnualLeaveKey } from "@/constants/globalConstants";
import StaffGradeService from "@/service/StaffGradeService";
import InputHelper from "@/common/helper/InputHelper";
import Settings from "../../constants/Settings";
export default {
  components: {},
  data() {
    return {
      menuRights: { allRights: {}, rightsForThisMenu: {} },
      menuId: Settings.MenuID.MM_AnnualLeavePlan,
      Settings: Settings,
      tableData: [],
      dictEnum: dictEnum,
      staffGradeList: [],
      staffGradeALDays: [],
      annualLeavePlan: new AnnualLeavePlan(),
      mode: "new"
    };
  },
  computed: {
    t() {
      return t;
    },
    annualLeavePlanDays() {
      return this.tableData.length > 0 ? this.tableData[0].GradeEntitle : [];
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    }
  },
  methods: {
    hasRight(key) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    inputDigitOnly(evt) {
      InputHelper.inputDigitOnly(evt);
    },
    initAnnualLeavePlan() {
      this.mode = "new";
      this.annualLeavePlan = new AnnualLeavePlan();

      for (let key in this.staffGradeALDays) {
        this.staffGradeALDays[key] = 1;
      }
    },
    editAnnualLeavePlan(plan) {
      this.mode = "edit";
      this.annualLeavePlan = plan;
      for(let i=0;i<this.staffGradeList.length;i++){
        for(let j=0;j<this.annualLeavePlan.GradeEntitle.length;j++){
          if(this.staffGradeList[i].StaffGrade==this.annualLeavePlan.GradeEntitle[j].StaffGrade){
            this.staffGradeALDays[this.staffGradeList[i].StaffGrade]=this.annualLeavePlan.GradeEntitle[j].DaysEntitle;
          }
        }
      }
    },
    async deleteAnnualLeavePlan(plan) {
      this.editAnnualLeavePlan(plan);
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: `${t.t(dictEnum.WARN_DeleteAnnualLeavePlan)}`,
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        const obj = {
          YOS: this.annualLeavePlan.YOS
        };

        const response = await LeavePlanService.deleteLeavePlan(obj);
        if (response.data.IsSuccess) {
          this.annualLeavePlan = new AnnualLeavePlan();
          SweetAlertService.success("Success", response.data.Message);
          this.getDataTable();
        } else {
          this.annualLeavePlan = new AnnualLeavePlan();
          SweetAlertService.warning("Warn", response.data.Message);
          this.getDataTable();
        }
      }
    },
    async getStaffGrade() {
      const obj = {};
      const response = await StaffGradeService.getStaffGrades(obj);
      if (response.data.IsSuccess) {
        this.staffGradeList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async editOrAddAnnualLeavePlan() {
      const leaveOfForDiffGrade = [];
      if (!this.annualLeavePlan.YOS) {
        SweetAlertService.warning(
          "Warn",
          this.t.t(dictEnum.LBL_YearOfService) +
            this.t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }
      if (
        parseInt(this.annualLeavePlan.YOS) <= 0 ||
        parseInt(this.annualLeavePlan.YOS) > 100
      ) {
        SweetAlertService.warning(
          "Warn",
          this.t.t(dictEnum.WARN_OutOfBound100)
        );
        return;
      }

      for (let key in this.staffGradeALDays) {
        if (
          parseInt(this.staffGradeALDays[key]) < 0 ||
          parseInt(this.staffGradeALDays[key]) > 100
        ) {
          SweetAlertService.warning(
            "Warn",
            this.t.t(dictEnum.WARN_OutOfBound100)
          );
          return;
        }

        leaveOfForDiffGrade.push({
          DaysEntitle: this.staffGradeALDays[key],
          StaffGrade: key
        });
      }

      const isAnyDayNotFilled = leaveOfForDiffGrade.find(x => !x.DaysEntitle);
      if(isAnyDayNotFilled){
        if(isAnyDayNotFilled.DaysEntitle==0){}else{
          if (isAnyDayNotFilled ||leaveOfForDiffGrade.length !== this.staffGradeList.length) 
          {
            SweetAlertService.warning("Warn",this.t.t(dictEnum.WARN_AnnualLeavePlanRequired));return;
          }
        }
      }

      const obj = {
        model: [
          {
            YOS: this.annualLeavePlan.YOS,
            LeaveType: AnnualLeaveKey,
            GradeEntitle: leaveOfForDiffGrade
          }
        ]
      };

      const response =
        this.mode === "new"
          ? await LeavePlanService.addLeavePlan(obj)
          : await LeavePlanService.updateLeavePlan(obj);
      if (response.data.IsSuccess) {
        this.annualLeavePlan = new AnnualLeavePlan();
        SweetAlertService.success("Success", response.data.Message);
        this.getDataTable();
      } else {
        this.annualLeavePlan = new AnnualLeavePlan();
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getDataTable() {
      const obj = {
        lang: this.$store.getters[StoreGetter.user].Lang
      };
      const response = await LeavePlanService.getLeavePlans(obj);

      if (response.data.IsSuccess) {
        this.tableData = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    }
  },
  mounted() {
    this.assignRights();
    this.getDataTable();
    this.getStaffGrade();
    this.initAnnualLeavePlan();
  }
};
</script>
<style scoped>
.input-group-text {
  background: white;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/S050000-MM/S050300-AnnualLeavePlan.vue